/**
 * O serviço de voz marca silêncio e ruído no meio da transcrição com etiquetas
 * entre sinais de menor e maior, como "<noise>" e "<no speech>". Elas não são
 * fala: não aparecem na tela e não contam como a pessoa ter falado.
 */
const MARKER = /<[a-z]+(?:[ _-][a-z]+){0,3}>/gi;

/** O pedaço de transcrição sem as etiquetas; vazio quando só havia etiqueta. */
export function cleanTranscript(text: string): string {
  const cleaned = text.replace(MARKER, '');
  return cleaned.trim() ? cleaned : '';
}
